import { gatewayApiGet } from "./api-config-gateway";

export function getUsers(queryParams, bearerToken) {
  return gatewayApiGet(
    `/vin.api.gateway.tenant/v1/tenant/user?dealerId=${queryParams.dealerId}`,
    bearerToken
  );
}
